import { render, staticRenderFns } from "./GeneralStatisticsWidget.vue?vue&type=template&id=daf3e178&scoped=true"
import script from "./GeneralStatisticsWidget.vue?vue&type=script&lang=js"
export * from "./GeneralStatisticsWidget.vue?vue&type=script&lang=js"
import style0 from "./GeneralStatisticsWidget.vue?vue&type=style&index=0&id=daf3e178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf3e178",
  null
  
)

export default component.exports